// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__WpjsF","colCheckbox":"styles_colCheckbox__APjxH"};